// extracted by mini-css-extract-plugin
export default {"root":"BizOverquotaInformer__root--2NHra","title":"BizOverquotaInformer__title--2TkmO"};